import { createSlider, openSlider } from './popup_image_slider.js';

function openImageInSlider(image) {
    const slideIndex = image.getAttribute('data-slide-index');

    if (slideIndex) {
        openSlider(slideIndex);
    }
}

function openGallery(gallery) {
    gallery.classList.add('imageGallery--visible');
}

function closeGallery(gallery) {
    gallery.classList.remove('imageGallery--visible');
}

function init() {
    const gallery = document.querySelector('.js_imageGallery'),
        openGalleryButton = document.querySelector('.js_imageGallery__openButton'),
        closeGalleryButton = document.querySelector('.js_imageGallery__closeButton'),
        images = [...document.querySelectorAll('.js_imageGallery__image')];

    if (gallery && openGalleryButton && closeGalleryButton) {
        openGalleryButton.addEventListener('click', e => openGallery(gallery));
        closeGalleryButton.addEventListener('click', e => closeGallery(gallery));
    }

    createSlider();

    images.forEach(image => image.addEventListener('click', e => openImageInSlider(image)));
}

$(document).ready(init);
